import { cn } from '@exam-room/utils';
import { cva } from 'class-variance-authority';

interface ChipProps {
  size?: 'sm' | 'md' | 'lg';
  variant: 'error' | 'success' | 'info' | 'warning' | 'gray';
  label: string;
}

const chipStyles = cva('w-fit rounded-[28px] border font-semibold', {
  variants: {
    size: {
      sm: 'py-0.5 px-2 text-xs',
      md: 'py-0.5 px-2.5 text-sm',
      lg: 'py-1 px-3 text-sm',
    },
    variant: {
      error: 'bg-red-50 text-danger-700 border-danger-500',
      success: 'bg-green-50 text-success-700 border-success-500',
      info: 'bg-blue-50 text-info-700 border-info-500',
      warning: 'bg-warning-100 text-warning-700 border-warning-500',
      gray: 'bg-gray-50 text-text-secondary border-gray-500',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default function Chip(props: ChipProps) {
  const { variant, label, size } = props;

  return <div className={cn([chipStyles({ size, variant })])}>{label}</div>;
}
